import React from "react";
import { FilterMode } from "./Filter";
import BasicGrid from "./Grid";

const NearToExpiryApprovedList =()=>{
    return(
        <>
        <FilterMode/>
        <BasicGrid/>
        </>
    )
};

export default NearToExpiryApprovedList;